module.exports = __webpack_public_path__ + "6b407109ddd8d3a95c728c4e37dd9d5d.png";